import tailwindIcon from "../assets/tailwind.svg";
import reactIcon from "../assets/react.svg";
import nodeIcon from "../assets/node.svg";
import expressIcon from "../assets/express.svg";
import mongodbIcon from "../assets/mongodbIcon.svg";
import sqlserverIcon from "../assets/sqlserver.svg";
import nextjsIcon from "../assets/nextjs.svg";
import postgresqlIcon from "../assets/postgresql.svg";
import typescriptIcon from "../assets/typescript.svg";
import socketioIcon from "../assets/socketioIcon.svg";
import prismaIcon from "../assets/prismaIcon.svg";
import fastapiIcon from "../assets/FastAPI.svg";
import googleGeminiIcon from "../assets/gemini-color.svg";
import pythonIcon from "../assets/pythonIcon.svg";
import openaiIcon from "../assets/openaiIcon.svg";
import langchainIcon from "../assets/langchainIcon.svg";
import qdrantIcon from "../assets/qdrantIcon.svg";
import sourced1 from "../assets/sourced1.png";
import sourced2 from "../assets/sourced2.png";
import cineverse1 from "../assets/cineverse1.jpg";
import cineverse2 from "../assets/cineverse2.jpg";
import cineverse3 from "../assets/cineverse3.jpg";
import cineverse4 from "../assets/cineverse4.png";
import cineverse5 from "../assets/cineverse5.png";
import hubspace1 from "../assets/hubspace1.jpeg";
import hubspace2 from "../assets/hubspace2.jpeg";
import hubspace3 from "../assets/hubspace3.jpeg";
import hubspace4 from "../assets/hubspace4.jpeg";
import hubspace5 from "../assets/hubspace5.jpeg";
import hubspace6 from "../assets/hubspace6.jpeg";
import circle1 from "../assets/circle1.png";
import circle2 from "../assets/circle2.png";
import circle3 from "../assets/circle3.png";
import konvo1 from "../assets/konvo1.png";
import konvo2 from "../assets/konvo2.png";
import konvo3 from "../assets/konvo3.png";
import konvo4 from "../assets/konvo4.png";
import evalvision1 from "../assets/evalvision1.png";
import evalvision2 from "../assets/evalvision2.png";
import evalvision3 from "../assets/evalvision3.png";
import evalvision4 from "../assets/evalvision4.png";
import evalvision5 from "../assets/evalvision5.png";
import evalvision6 from "../assets/evalvision6.png";
import evalvision7 from "../assets/evalvision7.png";
import evalvision8 from "../assets/evalvision8.png";
import evalvision9 from "../assets/evalvision9.png";
import maalmanager1 from "../assets/maalmanager1.png";
import maalmanager2 from "../assets/maalmanager2.png";
import maalmanager3 from "../assets/maalmanager3.png";
import maalmanager4 from "../assets/maalmanager4.png";
import maalmanager5 from "../assets/maalmanager5.png";

export const myprojects = [
  {
    index: 0,
    title: "EvalVision AI",
    description: `EvalVision AI is a modern automated grading and evaluation web application designed to offer educators a streamlined and intelligent assessment experience. Built with a clean, responsive UI, a robust backend architecture, and a dedicated AI processing service, the platform emphasizes accuracy, efficiency by making it easy for teachers to evaluate student submissions and provide detailed feedback anytime.

        Exam Management: Users can intuitively create and organize exams, each complete with designated rubrics and specific grading criteria.

        Automated AI Grading: Seamlessly process student submissions through advanced AI and OCR services that extract text and evaluate answers based on established rubrics.

        Submission Tracking: A built-in upload portal allows educators to quickly submit student assignments, track their grading status, and manage batches of documents.

        Detailed Evaluation Insights: A modern central dashboard summarizing assignment scores, AI-generated feedback, and criteria breakdowns for quick access.

        Interactive Results Panel: Explore student performance charts, review AI scoring decisions, and easily override or adjust grades to maintain full control over the assessment process.

        Secure Handling: Safe submission and storage of exams, rubrics, and sensitive student data with validated endpoints and robust backend protection.

        Responsive UI: Fully optimized for mobile, tablet, and desktop to ensure a smooth user experience across devices.`,
    techstack: [
      reactIcon,
      nodeIcon,
      expressIcon,
      typescriptIcon,
      mongodbIcon,
      fastapiIcon,
      googleGeminiIcon
    ],
    images: [
      evalvision1,
      evalvision2,
      evalvision3,
      evalvision4,
      evalvision5,
      evalvision6,
      evalvision7,
      evalvision8,
      evalvision9
    ],
    githublink: "https://github.com/rajaomar99/EvalVisionAI",
    sitelink: "https://evalvisionai.vercel.app",
  },
  {
    index: 1,
    title: "Sourced",
    description: `Sourced is a private document assistant designed to let a company ask questions of its own files and get back answers it can actually verify. Built on a Python/FastAPI service handling retrieval and generation, with Qdrant for vector search and LangChain orchestrating the pipeline, the platform emphasizes accuracy, traceability, and safe handling of confidential material, making it possible to find a single clause, policy line, or commitment in seconds instead of an afternoon. It was originally built for a pharmaceutical manufacturer's contract library, where a confidently wrong answer is a regulatory problem rather than an inconvenience.

        Grounded Answers: Every response is generated only from the retrieved source text, with the exact document and line it came from attached, so any answer can be checked in one click rather than taken on trust.

        Honest Refusals: When the retrieved context doesn't contain the answer, the assistant says so instead of producing a confident guess, which is the failure mode that makes most generative tools unusable for professional work.

        Ingestion Pipeline: PDFs, Word files, and scanned pages are parsed, cleaned, chunked, and embedded through a pipeline that preserves each chunk's position in its original document, which is what makes precise citation possible.

        Semantic Search: Questions are answered by meaning rather than keyword match, and across the entire corpus at once, surfacing every place a topic appears including documents the user didn't know existed.

        Conversational Follow-ups: Context carries across turns, so a broad question can be narrowed over several messages without restating it, with fresh citations attached to every answer.

        Audit Trail: Every question, answer, and source returned is logged, giving a complete record of how the system has been used and what it reported.

        Private Deployment: The service runs inside the client's own environment. Documents are never handed to a third-party store and are never used to train a model.

        Responsive UI: Fully optimized for mobile, tablet, and desktop, so the assistant is as usable from a phone mid-meeting as it is from a desk.`,
    techstack: [
      pythonIcon,
      fastapiIcon,
      openaiIcon,
      langchainIcon,
      qdrantIcon,
    ],
    images: [
      sourced1,
      sourced2
    ],
    githublink: "https://github.com/rajaomar99/Sourced",
    sitelink: "",
  },
  {
    index: 2,
    title: "HubSpace By TT",
    description: `HubSpace by TT is a modern coworking space management web application designed to offer professionals a streamlined and interactive workspace-booking experience. Built with a clean, responsive UI and a robust backend architecture, the platform emphasizes convenience, flexibility, and user engagement—making it easy for individuals and teams to access coworking services anytime.

        Plan Exploration: Users can browse through a variety of coworking plans, each with detailed description and features.

        Room Booking: Seamlessly book meeting rooms or gaming rooms through an intuitive scheduling interface that shows real-time availability.

        Contact Form: A built-in contact portal allows users to quickly reach out with inquiries, partnership requests, or support needs.

        User-Friendly Dashboard: A modern central dashboard summarizing plan details, benefits and faq's for quick access.

        Workspace Highlights: Explore amenities, workspace photos, and environment details to get a clear sense of the coworking experience.

        Secure Handling: Safe submission of booking and contact details with validated forms and backend protection.

        Admin Panel: An admin panel where authorized people can view bookings by date and delete bookings.

        Responsive UI: Fully optimized for mobile, tablet, and desktop to ensure a smooth user experience across devices.`,
    techstack: [reactIcon, nodeIcon, expressIcon, mongodbIcon, tailwindIcon],
    images: [hubspace1, hubspace2, hubspace3, hubspace4, hubspace5, hubspace6],
    githublink: "https://github.com/rajaomar99/HubSpaceByTT",
    sitelink: "https://www.hubspacebytt.com",
  },
  {
    index: 3,
    title: "Maal Manager",
    description: `Maal Manager is a modern Restock planning & reorder alerts tool designed to help Pakistani kiryana store owners replace paper notebooks with a fast, mobile-first digital system. Built as a take-home assignment for a YC-backed Pakistani startup, the platform focuses on simplicity, real-time visibility, and a UX tailored specifically for local store owners — making it easy to track stock, catch shortages early, and stay on top of daily operations.

        Dashboard Overview: A central dashboard showing total products, low-stock count, out-of-stock count, total inventory value in PKR, today's revenue, and a live feed of the last 10 stock movements.

        Inventory Management: Browse, search, and filter all products by category or stock status. Add new products, edit details, delete with confirmation, and view a full movement history per product.

        Quick Stock Updates: Tap + or − directly from the product list for instant optimistic stock updates — no page reload, with a toast notification on every change.

        Reorder Alerts: A dedicated alerts page lists every product at or below its minimum threshold, sorted by urgency, with a one-tap restock action to log incoming quantities.

        Alert Banner: A persistent banner appears on every page showing a live count of items that need restocking, with a direct link to the alerts page.

        PDF Export & WhatsApp Share: Generate a printable restock list and share it with a supplier in one tap — built for how kiryana store owners actually communicate.

        Pakistani-First UX: PKR currency formatting (Rs. 1,250), Urdu script support, and pre-seeded with 15 real Pakistani products (Tapal Danedar, Shan Masala, Dalda Cooking Oil, etc.) so the app feels lived-in from day one.

        Mobile-First Design: Bottom navigation on mobile and a sidebar on desktop, with large touch targets optimized for small-screen use.`,
    techstack: [
      nextjsIcon,
      typescriptIcon,
      postgresqlIcon,
      prismaIcon,
      tailwindIcon,
    ],
    images: [
      maalmanager1,
      maalmanager2,
      maalmanager3,
      maalmanager4,
      maalmanager5,
    ],
    githublink: "https://github.com/rajaomar99/MaalManager",
    sitelink: "https://maal-manager.vercel.app",
  },
  {
    index: 4,
    title: "Circle",
    description: `Circle is a full-stack social media web application designed to provide users with a seamless and engaging community experience. Built using Next.js 14 with React on the frontend, Prisma ORM and PostgreSQL for robust database management, and Clerk for authentication, the platform is optimized for performance, real-time interactivity, and scalability.
        
        Posts & Image Sharing: Users can create text and image-based posts with support for media uploads powered by UploadThing.

        Likes & Comments: Authenticated users can like and comment on posts, fostering community engagement and discussion.

        Follow System: Users can follow and unfollow others, building a personalized feed tailored to their social circle.

        User Profiles: Each user has a dedicated profile page showcasing their posts, bio, location, website, and follower/following stats.

        Real-Time Notifications: Users receive instant notifications for likes, comments, and new followers, keeping them always in the loop.

        Who to Follow: A smart sidebar suggests relevant users to follow, helping users grow their network.

        User Authentication: Secure sign-in and sign-up powered by Clerk, with protected routes enforced via middleware.

        Responsive UI: Mobile-friendly design with a dedicated mobile navbar and adaptive layouts optimized for all screen sizes.
        `,
    techstack: [
      nextjsIcon,
      typescriptIcon,
      postgresqlIcon,
      prismaIcon,
      tailwindIcon,
    ],
    images: [circle1, circle2, circle3],
    githublink: "https://github.com/rajaomar99/Circle",
    sitelink: "",
  },
  {
    index: 5,
    title: "CineVerse",
    description: `CineVerse is a full-stack theater management web application designed to provide users with a seamless and interactive movie-booking experience. Built using React on the frontend, Node.js and Express on the backend, and SQL Server for robust database management, the platform is optimized for performance, usability, and scalability.

        Seat and Show Selection: Users can view available shows and select seats in real-time via an intuitive interface.

        User Authentication: Secure login, signup using jwt/bcrypt.

        Movie Search: Easily search for movies by title.

        Top Rated Movies: Browse a dynamically generated list of the highest-rated movies.

        Reviews & Ratings: Authenticated users can leave reviews and rate movies, helping others choose what to watch.

        Newsletter Subscription: Users can subscribe to the newsletter and receive email updates about upcoming movies, promotions, and offers.

        Responsive UI: Mobile-friendly and optimized for various screen sizes for the best viewing experience.`,
    techstack: [reactIcon, nodeIcon, expressIcon, sqlserverIcon],
    images: [cineverse1, cineverse2, cineverse3, cineverse4, cineverse5],
    githublink: "https://github.com/rajaomar99/CineVerse",
    sitelink: "",
  },
  {
    index: 6,
    title: "Konvo",
    description: `Konvo is a full-stack real-time chat web application designed to provide users with a seamless and interactive messaging experience. Built using React on the frontend, Node.js and Express on the backend, and MongoDB for robust database management, the platform is optimized for performance, usability, and scalability.

        Real-Time Communication: Users can send and receive instant messages in real-time via an intuitive interface.

        User Authentication: Secure login, signup using jwt/bcrypt.

        Image Sharing: Easily upload and share images in conversations.

        Online Status: View a dynamically updated indicator of active and offline users.

        Modern Interface: Authenticated users can enjoy a clean, light-themed UI, making conversations visually engaging.

        State Management: Application state is managed efficiently using Zustand, ensuring an optimal and bug-free messaging experience.

        Responsive UI: Mobile-friendly and optimized for various screen sizes for the best viewing experience.`,
    techstack: [
      reactIcon,
      nodeIcon,
      expressIcon,
      mongodbIcon,
      tailwindIcon,
      socketioIcon,
    ],
    images: [konvo1, konvo2, konvo3, konvo4],
    githublink: "https://github.com/rajaomar99/Konvo",
    sitelink: "",
  },
];
